import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-facebook",
  "use": "icon-facebook-usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 19\" id=\"icon-facebook\"><path d=\"M16.868.503h-14c-1.1 0-2 .9-2 2v14c0 1.101.9 2 2 2h7v-7h-2V9.028h2v-2.05c0-2.164 1.212-3.684 3.766-3.684l1.803.002v2.605H14.24c-.994 0-1.372.746-1.372 1.438v1.69h2.568l-.568 2.474h-2v7h4c1.1 0 2-.899 2-2v-14c0-1.1-.9-2-2-2Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol